import i18n from 'i18n';

const { t } = i18n;

const calculateDays = (startDate, endDate) => {
  const startDateValue = new Date(startDate);
  const endDateValue = new Date(endDate);
  const timeDifference = endDateValue.getTime() - startDateValue.getTime();
  const days = Math.ceil(timeDifference / (1000 * 3600 * 24));
  return days;
};

const isValidCustomDate = (startDate, endDate) => {
  const daysCount = calculateDays(startDate, endDate);
  return !Number.isNaN(daysCount) && daysCount > 0;
};

const formatDateForInput = (dateValue) => {
  const date = new Date(dateValue);
  const day = String(date.getDate())?.padStart(2, '0');
  const month = String(date.getMonth() + 1)?.padStart(2, '0');
  const year = String(date.getFullYear());
  return `${year}/${month}/${day}`;
};

const getLastYearRange = () => {
  const startDate = new Date();
  startDate.setFullYear(startDate.getFullYear() - 1);
  const endDate = new Date();
  return [formatDateForInput(startDate), formatDateForInput(endDate)];
};

const getLastWeekRange = () => {
  const startDate = new Date();
  startDate.setDate(startDate.getDate() - 7);
  const endDate = new Date();
  return [formatDateForInput(startDate), formatDateForInput(endDate)];
};

const getLastMonthRange = () => {
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 1);
  const endDate = new Date();
  return [formatDateForInput(startDate), formatDateForInput(endDate)];
};

const getLast6MonthsRange = () => {
  const startDate = new Date();
  startDate.setMonth(startDate.getMonth() - 6);
  const endDate = new Date();
  return [formatDateForInput(startDate), formatDateForInput(endDate)];
};

const getfilterOptions = () => ([
  { id: 0, description: t('order_history_filter_last_week') },
  { id: 1, description: t('order_history_filter_last_month') },
  { id: 2, description: t('order_history_filter_last_6_months') },
  { id: 3, description: t('order_history_filter_last_year') },
  { id: 4, description: t('order_history_filter_custom') },
]);
const dateRegex = /^(19|20)\d{2}\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])$/;

const isDateRangeValid = (start, end) => {
  if (!dateRegex.test(start) || !dateRegex.test(end)) return t('order_history_filter_invalid_date_format');
  const todaysDate = new Date();
  const startDate = new Date(start);
  const endDate = new Date(end);
  if ((startDate > endDate) || (endDate > todaysDate) || (startDate > todaysDate)) return t('order_history_filter_invalid_date_range');
  return '';
};

const DATE_RANGES = {
  LAST_WEEK: 0,
  LAST_MONTH: 1,
  LAST_6_MONTHS: 2,
  LAST_YEAR: 3,
  CUSTOM: 4,
};

export {
  getfilterOptions, getLastWeekRange, getLastMonthRange, getLast6MonthsRange, getLastYearRange, calculateDays, isValidCustomDate,
  dateRegex, formatDateForInput, DATE_RANGES, isDateRangeValid,
};
